import React from "react";
import { Text, Flex } from "@costar/theme-ui";
var pointerEventsSx = {
    "pointer-events": "none",
};
export var CustomToast = function (_a) {
    var toastMsg = _a.toastMsg, _b = _a.marginTop, marginTop = _b === void 0 ? "30%" : _b;
    return (React.createElement(Flex, { p: "md", bg: "primary", borderRadius: "2rem", justifyContent: "center", alignItems: "center", marginTop: marginTop, sx: pointerEventsSx },
        React.createElement(Text, { fontSize: "sm", color: "white" }, toastMsg)));
};
export var CustomPlacardToast = function (_a) {
    var toastMsg = _a.toastMsg, _b = _a.marginTop, marginTop = _b === void 0 ? "30%" : _b;
    return (React.createElement(Flex, { p: "lg", bg: "primary", borderRadius: "2rem", justifyContent: "center", alignItems: "center", marginTop: marginTop, ml: "md", mr: "md", sx: pointerEventsSx },
        React.createElement(Text, { fontSize: "sm", color: "white" }, toastMsg)));
};
//# sourceMappingURL=CustomToast.js.map